import { baseSubscription } from '@/utils/subscriptionHandler';
import Subscriptions from '@/services/graphql/subscriptions';
const subscribeForWorkspacePages = (variables, next) => baseSubscription({
  variables,
  next,
  subscriptionFunction: Subscriptions.subscribeWorkspacePageChange,
  unsubscribe: false,
},);
export { subscribeForWorkspacePages };
